import { CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthHOC from "./HOC/AuthHOC";
import useAccessModule from "./hooks/useAccessModule";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "./models/userAccess/UserAccess.model";
import { setUserData } from "./redux/slices/AuthSlice";
import AssetsListingWrapper from "./screens/Assets/list/AssetsListingWrapper";
import BatchListingWrapper from "./screens/Batch/List/BatchListingWrapper";
import AssignmentListingWrapper from "./screens/Batch/View/Tabs/Assignment/List/AssignmentListingWrapper";
import BatchStudentAttendanceListingWrapper from "./screens/Batch/View/Tabs/Attendance/BatchStudentAttendanceListingWrapper";
import SingleDayLayoutWrapper from "./screens/Batch/View/Tabs/LectureNotes/SingleDayLayout/SingleDayLayoutWrapper";
import ViewLectureNotesWrapper from "./screens/Batch/View/Tabs/LectureNotes/View/ViewLectureNotesWrapper";
import BatchRecordingListingWrapper from "./screens/Batch/View/Tabs/Recordings/List/BatchRecordingListingWrapper";
import BatchesStudentListingWrapper from "./screens/Batch/View/Tabs/Student/BatchesStudentListingWrapper";
import ViewBatchLayoutWrapper from "./screens/Batch/View/ViewBatchLayoutWrapper";
import AccountListingWrapper from "./screens/Configurations/Accounts/List/AccountListingWrapper";
import BranchListingWrapper from "./screens/Configurations/Branches/List/BranchListingWrapper";
import ChapterListingWrapper from "./screens/Configurations/Chapters/List/ChapterListingWrapper";
import CommunicationMethodListingWrapper from "./screens/Configurations/CommunicationMethod/List/CommunicationMethodListingWrapper";
import ConfigurationLayout from "./screens/Configurations/ConfigurationLayout";
import CouponListingWrapper from "./screens/Configurations/Coupons/List/CouponListingWrapper";
import CourseLayout from "./screens/Configurations/Courses/CourseLayout";
import CourseListingWrapper from "./screens/Configurations/Courses/List/CourseListingWrapper";
import DayPlanningListingWrapper from "./screens/Configurations/Courses/Tabs/DayPlanning/List/DayPlanningListingWrapper";
import CourseDetailsWrapper from "./screens/Configurations/Courses/Tabs/Details/CourseDetailsWrapper";
import SubCourseListingWrapper from "./screens/Configurations/Courses/Tabs/SubCourses/List/SubCourseListingWrapper";
import Dispositions from "./screens/Configurations/Dispositions/Dispositions";
import ExpenseCategoryListingWrapper from "./screens/Configurations/ExpenseCategories/List/ExpenseCategoryListingWrapper";
import HolidayCalendarListingWrapper from "./screens/Configurations/HolidayCalendar/List/HolidayCalendarListingWrapper";
import InquiryLabelsListingWrapper from "./screens/Configurations/InquryLabels/List/InquiryLabelsListingWrapper";
import LanguageListingWrapper from "./screens/Configurations/Language/List/LanguageListingWrapper";
import Locations from "./screens/Configurations/Location/Location";
import ModeListingWrapper from "./screens/Configurations/Modes/List/ModeListingWrapper";
import ModuleListingWrapper from "./screens/Configurations/Modules/List/ModuleListingWrapper";
import ModuleAndChapterListing from "./screens/Configurations/ModulesAndChapterLayout/ModuleAndChapterListing";
import ModulesAndChapterLayoutWrapper from "./screens/Configurations/ModulesAndChapterLayout/ModulesAndChapterLayoutWrapper";
import DashboardWrapper from "./screens/Dashboard/DashboardWrapper";
import ExpenseListingWrapper from "./screens/Finance/Expense/List/ExpenseListingWrapper";
import FinanceLayout from "./screens/Finance/FinanceLayout";
import UpComeingPaymentsListingWrapper from "./screens/Finance/UpComeingPayments/List/UpComeingPaymentsListingWrapper";
import AddFollowUpFormWrapper from "./screens/FollowUp/Add/AddFollowUpFormWrapper";
import EditFollowUpFormWrapper from "./screens/FollowUp/Edit/EditFollowUpFormWrapper";
import FollowUpListingWrapper from "./screens/FollowUp/List/FollowUpListingWrapper";
import GoalListingWrapper from "./screens/GoalsConfigurations/Goal/List/GoalListingWrapper";
import ViewGoalWrapper from "./screens/GoalsConfigurations/Goal/View/ViewGoalWrapper";
import GoalCategoriesListingWrapper from "./screens/GoalsConfigurations/GoalCategories/List/GoalCategoriesListingWrapper";
import GoalsConfigurationLayout from "./screens/GoalsConfigurations/GoalsConfigurationLayout";
import AddInquiryFormWrapper from "./screens/Inquiry/Add/AddInquiryFormWrapper";
import AcademicAndWorkHistory from "./screens/Inquiry/Component/AcademicAndWorkHistory/AcademicAndWorkHistory";
import ContactInformation from "./screens/Inquiry/Component/ContactInformation/ContactInformation";
import CourseIntersted from "./screens/Inquiry/Component/CourseIntersted/CourseIntersted";
import PersonalInformation from "./screens/Inquiry/Component/PersonalInformation/PersonalInformation";
import Preference from "./screens/Inquiry/Component/Preference/Preference";
import Source from "./screens/Inquiry/Component/Source/Source";
import Summary from "./screens/Inquiry/Component/Summary/Summary";
import EditInquiryWrapper from "./screens/Inquiry/Edit/EditInquiryWrapper";
import InquiryLayoutWrapper from "./screens/Inquiry/Edit/Layout/InquiryLayoutWrapper";
import InquiryListingWrapper from "./screens/Inquiry/List/InquiryListingWrapper";
import LandingPage from "./screens/LandingPage";
import ManagementAdminsLayouts from "./screens/ManagementAdmins/ManagementAdminsLayouts";
import AddUserAccessWrapper from "./screens/ManagementAdmins/Roles/Add/AddUserAccessWrapper";
import EditUserAccessWrapper from "./screens/ManagementAdmins/Roles/EDIT/EditUserAccessWrapper";
import UserRoleListingWrapper from "./screens/ManagementAdmins/Roles/List/UserRoleListingWrapper";
import UserListingWrapper from "./screens/ManagementAdmins/User/List/UserListingWrapper";
import CampaignGroupListingWrapper from "./screens/Marketing/Campaign Group/List/CampaignGroupListingWrapper";
import CampaignListingWrapper from "./screens/Marketing/Campaign/List/CampaignListingWrapper";
import ChannelListingWrapper from "./screens/Marketing/Channel/List/ChannelListingWrapper";
import MarketingLayout from "./screens/Marketing/MarketingLayout";
import PendingFollowupListingWrapper from "./screens/Pending-Followup/List/PendingFollowupListingWrapper";
import QuestionBankListingWrapper from "./screens/Question-Bank/List/QuestionBankListingWrapper";
import Receipt from "./screens/Receipt/Receipt";
import RecordingRequestListingWrapper from "./screens/RecordingRequest/List/RecordingRequestListingWrapper";
import RegistrationLayout from "./screens/Registration/RegistrationLayout";
import RegistrationLinkListingWrapper from "./screens/Registration/RegistrationLinks/List/RegistrationLinkListingWrapper";
import RegistrationRequestsListingWrapper from "./screens/Registration/RegistrationRequests/List/RegistrationRequestsListingWrapper";
import ResourceListingWrapper from "./screens/Resource/List/ResourceListingWrapper";
import AddStudentFormWrapper from "./screens/Student/Add/AddStudentFormWrapper";
import StudentAttendanceListingWrapper from "./screens/Student/Components/Attendance/List/StudentAttendanceListingWrapper";
import AssignBatchesWrapper from "./screens/Student/Components/Batches/Add/AssignBatchesWrapper";
import BatchesListingWrapper from "./screens/Student/Components/Batches/List/BatchesListingWrapper";
import StudentCourseListing from "./screens/Student/Components/Courses/List/CouresListingForm";
import StudentAcademicAndWorkHistory from "./screens/Student/Components/StudentAcademicAndWorkHistory/AcademicAndWorkHistory";
import StudentAssignmentListingWrapper from "./screens/Student/Components/StudentAssignment/List/StudentAssignmentListingWrapper";
import StudentContactInformation from "./screens/Student/Components/StudentContactInformation/ContactInformation";
import StudentPaymentLayout from "./screens/Student/Components/StudentPayments/StudentPaymentLayout";
import StudentPersonalInformation from "./screens/Student/Components/StudentPersonalInformation/PersonalInformation";
import EditStudentFormWrapper from "./screens/Student/Edit/EditStudentFormWrapper";
import StudentListingWrapper from "./screens/Student/List/StudentListingWrapper";
import TeamResourceListingWrapper from "./screens/TeamResource/List/TeamResourceListingWrapper";
import AssignTestWrapper from "./screens/TestModule/AssignTest/List/AssignTestWrapper";
import QuestionCategoryListingWrapper from "./screens/TestModule/QuestionCategory/List/QuestionCategoryListingWrapper";
import QuestionTechnologyListingWrapper from "./screens/TestModule/QuestionTechnolgy/List/QuestionTechnologyListingWrapper";
import TestCheckListingWrapper from "./screens/TestModule/TestCheck/List/TestCheckListingWrapper";
import SingleViewFormWrapper from "./screens/TestModule/TestCheck/View/SingleViewFormWrapper";
import TestModuleLayout from "./screens/TestModule/TestModuleLayout";
import AddTestQuestionFormWrapper from "./screens/TestModule/TestQuestions/Add/AddTestQuestionFormWrapper";
import EditTestQuestionFormWrapper from "./screens/TestModule/TestQuestions/Edit/EditTestQuestionFormWrapper";
import TestQuestionListingWrapper from "./screens/TestModule/TestQuestions/List/TestQuestionListingWrapper";
import AddTestSeriesFormWrapper from "./screens/TestModule/TestSeries/Add/AddTestSeriesFormWrapper";
import EditTestSeriesFormWrapper from "./screens/TestModule/TestSeries/Edit/EditTestSeriesFormWrapper";
import TestSeriesListingWrapper from "./screens/TestModule/TestSeries/List/TestSeriesListingWrapper";
import AddTrainerFormWrapper from "./screens/Trainer/Add/AddTrainerFormWrapper";
import EditTrainerFormWrapper from "./screens/Trainer/Edit/EditTrainerFormWrapper";
import TrainerListingWrapper from "./screens/Trainer/List/TrainerListingWrapper";
import TransactionsListingWrapper from "./screens/Transactions/List/TransactionsListingWrapper";
import AddBlogFormWrapper from "./screens/websiteContent/Blogs/Add/AddBlogFormWrapper";
import EditBlogFormWrapper from "./screens/websiteContent/Blogs/Edit/EditBlogFormWrapper";
import BlogsListingWrapper from "./screens/websiteContent/Blogs/List/BlogsListingWrapper";
import ViewBlog from "./screens/websiteContent/Blogs/View/ViewBlog";
import JobListingWrapper from "./screens/websiteContent/JobBoard/List/JobListingWrapper";
import StudentTestimonialListingWrapper from "./screens/websiteContent/StudentTestimonials/List/StudentTestimonialListingWrapper";
import WebCourseListingWrapper from "./screens/websiteContent/WebCourseUpdate/List/WebCourseListingWrapper";
import WebCourseLayout from "./screens/websiteContent/WebCourseUpdate/View/WebCourseLayout";
import WebsiteContentLayout from "./screens/websiteContent/websiteContentLayout";
import PageNotFound from "./utils/PageNotFound";
import Welcome from "./utils/Welcome";
import BasicDetailsCourseFormWrapper from "./screens/websiteContent/WebCourseUpdate/Components/BasicDetailsCourse/BasicDetailsCourseFormWrapper";
import CourseContentFormWrapper from "./screens/websiteContent/WebCourseUpdate/Components/CourseContent/CourseContentFormWrapper";
import AdditionalDescriptionFormWrapper from "./screens/websiteContent/WebCourseUpdate/Components/AdditionalDescription/AdditionalDescriptionFormWrapper";
import NewInquiryListingWrapper from "./screens/NewInquiry/List/NewInquiryListingWrapper";
import ViewNewInquiryWrapper from "./screens/NewInquiry/View/ViewNewInquiryWrapper";
import RecordingRulesListingWrapper from "./screens/RecordingRules/List/RecordingRulesListingWrapper";
import FinanceDashboardWrapper from "./screens/Finance/Dashboard/FinanceDashboardWrapper";


const PageRoutes = () => {
  const dispatch = useDispatch();
  const userDataLs = localStorage.getItem("userData");
  const userData = JSON?.parse(userDataLs as string);
  dispatch(setUserData(userData ? userData : null));
  const { userAccessIsloading } = useAccessModule();
  if (userAccessIsloading) {
    // Show loading spinner if user access data is not available yet
    return (
      <div className="flex items-center justify-center w-screen h-screen bg-white">
        <CircularProgress />
      </div>
    );
  }
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/welcome" element={<Welcome />} />
          <Route
            path="/"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.DASHBOARD}
                component={<LandingPage />}
              />
            }
          />

          <Route
            path="/dashboard"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.DASHBOARD}
                component={<DashboardWrapper />}
              />
            }
          />
          <Route
            path="/configuration"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.CONFIGURATION}
                component={<ConfigurationLayout />}
              />
            }
          >
            <Route
              path="modes"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.MODES}
                  component={<ModeListingWrapper />}
                />
              }
            />
            <Route
              path="modules-chapter"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BRANCHES}
                  component={<ModuleAndChapterListing />}
                />
              }
            />
            <Route
              path="modules-chapter/:moduleId"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BRANCHES}
                  component={<ModulesAndChapterLayoutWrapper />}
                />
              }
            />
            <Route
              path="inqury-labels"
              element={<InquiryLabelsListingWrapper />}
            />

            <Route
              path="locations"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.LOCATIONS}
                  component={<Locations />}
                />
              }
            />
            <Route
              path="dispositions"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.DISPOSITION}
                  component={<Dispositions />}
                />
              }
            />

            <Route
              path="branches"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BRANCHES}
                  component={<BranchListingWrapper />}
                />
              }
            />

            <Route
              path="courses"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.COURSES}
                  component={<CourseListingWrapper />}
                />
              }
            />
            <Route path="courses/:courseId" element={<CourseLayout />}>
              <Route path="details" element={<CourseDetailsWrapper />} />
              <Route path="sub-courses" element={<SubCourseListingWrapper />} />
              <Route
                path="day-planing"
                element={<DayPlanningListingWrapper />}
              />
            </Route>
            <Route
              path="chapters"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.CHAPTERS}
                  component={<ChapterListingWrapper />}
                />
              }
            />
            <Route
              path="modules"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.MODULES}
                  component={<ModuleListingWrapper />}
                />
              }
            />
            <Route
              path="communication-method"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.COMMUNICATION_METHOD}
                  component={<CommunicationMethodListingWrapper />}
                />
              }
            />

            <Route
              path="holiday-calendar"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.HOLIDAY_CALENDAR}
                  component={<HolidayCalendarListingWrapper />}
                />
              }
            />
            <Route
              path="language"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.LANGUAGE}
                  component={<LanguageListingWrapper />}
                />
              }
            />
          </Route>

          <Route
            path="/finance"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.FINANCE}
                component={<FinanceLayout />}
              />
            }
          >
            <Route
              path="expense-categories"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.EXPENSE_CATEGORIES}
                  component={<ExpenseCategoryListingWrapper />}
                />
              }
            />

            <Route
              path="finance-dashboard"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.EXPENSE_CATEGORIES}
                  component={<FinanceDashboardWrapper />}
                />
              }
            />
            <Route
              path="accounts"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.ACCOUNTS}
                  component={<AccountListingWrapper />}
                />
              }
            />
            <Route
              path="transactions"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TRANSACTIONS}
                  component={<TransactionsListingWrapper />}
                />
              }
            />
            <Route
              path="expenses"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.EXPENSES}
                  component={<ExpenseListingWrapper />}
                />
              }
            />
            <Route
              path="upcomeing-payments"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.UPCOMEING_PAYMENTS}
                  component={<UpComeingPaymentsListingWrapper />}
                />
              }
            />
            <Route
              path="coupon"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.COUPONS}
                  component={<CouponListingWrapper />}
                />
              }
            />
          </Route>
          <Route
            path="/marketing"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.MARKETING}
                component={<MarketingLayout />}
              />
            }
          >
            <Route
              path="channel"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.CHANNEL}
                  component={<ChannelListingWrapper />}
                />
              }
            />
            <Route
              path="campaign"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.CAMPAIGN}
                  component={<CampaignListingWrapper />}
                />
              }
            />
            <Route
              path="campaign-group"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.CAMPAIGN_GROUP}
                  component={<CampaignGroupListingWrapper />}
                />
              }
            />
          </Route>
          <Route
            path="/inquiries"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.INQUIRIES}
                component={<InquiryListingWrapper />}
              />
            }
          />
          {/* BATCH  */}
          <Route
            path="/batches"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.BATCHES}
                component={<BatchListingWrapper />}
              />
            }
          />
          <Route path="/batches/:batchId" element={<ViewBatchLayoutWrapper />}>
            <Route
              path="students" //Under Batch
              element={<BatchesStudentListingWrapper />}
            />
            <Route
              path="attendance" //Under Batch
              element={<BatchStudentAttendanceListingWrapper />}
            />
            <Route
              path="lecture-notes" //Under Batch
              element={<ViewLectureNotesWrapper />}
            />
            <Route
              path="assignment" //Under Batch
              element={<AssignmentListingWrapper />}
            />
            <Route
              path="recording" //Under Batch
              element={<BatchRecordingListingWrapper />}
            />
            <Route
              path="lecture-notes/:dayId" //Under Batch
              element={<SingleDayLayoutWrapper />}
            />
          </Route>
          <Route
            path="/inquiries/edit/:inquiryId"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.INQUIRIES}
                component={<InquiryLayoutWrapper />}
              />
            }
          >
            <Route
              path="details"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.INQUIRIES}
                  component={<EditInquiryWrapper />}
                />
              }
            >
              <Route
                path="personal-information"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<PersonalInformation />}
                  />
                }
              />
              <Route
                path="interested-course"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<CourseIntersted />}
                  />
                }
              />
              <Route
                path="contact-information"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<ContactInformation />}
                  />
                }
              />
              <Route
                path="academic-and-work-history"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<AcademicAndWorkHistory />}
                  />
                }
              />
              <Route
                path="source"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<Source />}
                  />
                }
              />
              <Route
                path="preference"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<Preference />}
                  />
                }
              />
              <Route
                path="summary"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<Summary />}
                  />
                }
              />
            </Route>
            <Route
              path="followup"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.INQUIRIES}
                  component={<FollowUpListingWrapper />}
                />
              }
            />
            <Route
              path="followup/add"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.INQUIRIES}
                  actionName={UserModuleActionTypes.ADD}
                  component={<AddFollowUpFormWrapper />}
                />
              }
            />
            <Route
              path="followup/edit/:followupId"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.INQUIRIES}
                  component={<EditFollowUpFormWrapper />}
                />
              }
            />
          </Route>
          <Route
            path="/inquiries/add"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.INQUIRIES}
                actionName={UserModuleActionTypes.ADD}
                component={<AddInquiryFormWrapper />}
              />
            }
          />
          <Route
            path="/trainer"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.TRAINER}
                component={<TrainerListingWrapper />}
              />
            }
          ></Route>
          <Route
            path="/trainer/add"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.TRAINER}
                actionName={UserModuleActionTypes.ADD}
                component={<AddTrainerFormWrapper />}
              />
            }
          />
          <Route
            path="/trainer/edit/:id"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.TRAINER}
                component={<EditTrainerFormWrapper />}
              />
            }
          />

          <Route
            path="/student"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.STUDENT}
                component={<StudentListingWrapper />}
              />
            }
          />
          <Route
            path="/student/add"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.STUDENT}
                actionName={UserModuleActionTypes.ADD}
                component={<AddStudentFormWrapper />}
              />
            }
          />

          <Route
            path="/student/edit/:studentId"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.STUDENT}
                component={<EditStudentFormWrapper />}
              />
            }
          >
            <Route
              path="personal-information"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<StudentPersonalInformation />}
                />
              }
            />
            <Route
              path="contact-information"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<StudentContactInformation />}
                />
              }
            />
            <Route
              path="academic-and-work-history"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<StudentAcademicAndWorkHistory />}
                />
              }
            />
            <Route
              path="batches"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<BatchesListingWrapper />}
                />
              }
            />
            <Route
              path="courses"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<StudentCourseListing />}
                />
              }
            />
            <Route
              path="payments"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<StudentPaymentLayout />}
                />
              }
            />
            <Route
              path="attendance"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<StudentAttendanceListingWrapper />}
                />
              }
            />
            <Route
              path="assignment"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.STUDENT}
                  component={<StudentAssignmentListingWrapper />}
                />
              }
            />
          </Route>
          <Route
            path="/student/edit/:studentId/batches/assign-batch"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.STUDENT}
                component={<AssignBatchesWrapper />}
              />
            }
          />
          <Route
            path="followup"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.INQUIRIES}
                component={<FollowUpListingWrapper />}
              />
            }
          />
          <Route
            path="pending-followups"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.PENDING_FOLLOWUP}
                component={<PendingFollowupListingWrapper />}
              />
            }
          />
          <Route
            path="admin"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.MANAGEMENTSADMINS}
                component={<ManagementAdminsLayouts />}
              />
            }
          >
            <Route
              path="user"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.USER}
                  component={<UserListingWrapper />}
                />
              }
            />
            <Route
              path="user-role"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.USER}
                  component={<UserRoleListingWrapper />}
                />
              }
            />
            <Route
              path="user-access"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.USER}
                  component={<AddUserAccessWrapper />}
                />
              }
            />
            <Route
              path="user-access/:roleId"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.USER}
                  component={<EditUserAccessWrapper />}
                />
              }
            />
          </Route>

          <Route
            path="question-bank"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.QUESTION}
                component={<QuestionBankListingWrapper />}
              />
            }
          />
          <Route
            path="resources"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.RESOURCE}
                component={<ResourceListingWrapper />}
              />
            }
          />
          <Route
            path="team-resources"
            element={<TeamResourceListingWrapper />}
          />
          <Route
            path="asset"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.ASSETS}
                component={<AssetsListingWrapper />}
              />
            }
          />
          <Route
            path="registration"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.REGISTRATION}
                component={<RegistrationLayout />}
              />
            }
          >
            <Route
              path="registration-links"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.REGISTRATION_LINKS}
                  component={<RegistrationLinkListingWrapper />}
                />
              }
            />
            <Route
              path="registration-requests"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.REGISTRATION_REQUESTS}
                  component={<RegistrationRequestsListingWrapper />}
                />
              }
            />
          </Route>
          <Route
            path="goals"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.GOAL_CONFIGURATION}
                component={<GoalsConfigurationLayout />}
              />
            }
          >
            <Route
              path="goal-categories"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.GOAL_CATEGORY}
                  component={<GoalCategoriesListingWrapper />}
                />
              }
            />
            <Route
              path="goal"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.GOAL}
                  component={<GoalListingWrapper />}
                />
              }
            />
            <Route
              path="goal/:id"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.GOAL}
                  component={<ViewGoalWrapper />}
                />
              }
            />
          </Route>

          <Route
            path="website-content"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.WEBSITE_CONTENT}
                component={<WebsiteContentLayout />}
              />
            }
          >
            <Route
              path="jobs"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.JOB_BOARD}
                  component={<JobListingWrapper />}
                />
              }
            />
            <Route
              path="student-testimonials"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TESTIMONIALS}
                  component={<StudentTestimonialListingWrapper />}
                />
              }
            />
            <Route
              path="blogs"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BLOGS}
                  component={<BlogsListingWrapper />}
                />
              }
            />
            <Route
              path="blogs/add"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BLOGS}
                  actionName={UserModuleActionTypes.ADD}
                  component={<AddBlogFormWrapper />}
                />
              }
            />
            <Route
              path="blogs/edit/:id"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BLOGS}
                  component={<EditBlogFormWrapper />}
                />
              }
            />
            <Route
              path="blogs/view/:id"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BLOGS}
                  component={<ViewBlog />}
                />
              }
            />
            <Route
              path="web-course"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.BLOGS}
                  component={<WebCourseListingWrapper />}
                />
              }
            />

            <Route
              path="web-course/:id"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.INQUIRIES}
                  component={<WebCourseLayout />}
                />
              }
            >
              <Route
                path="details"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<BasicDetailsCourseFormWrapper />}
                  />
                }
              />
              <Route
                path="course-content"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<CourseContentFormWrapper />}
                  />
                }
              />
              <Route
                path="additional-details"
                element={
                  <AuthHOC
                    moduleName={UserModuleNameTypes.INQUIRIES}
                    component={<AdditionalDescriptionFormWrapper />}
                  />
                }
              />
            </Route>
          </Route>

          <Route
            path="test-module"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.TEST_MODULE}
                component={<TestModuleLayout />}
              />
            }
          >
            <Route
              path="category"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.QUESTION_CATEGORY}
                  component={<QuestionCategoryListingWrapper />}
                />
              }
            />
            <Route
              path="technology"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.QUESTION_TECHNOLOGY}
                  component={<QuestionTechnologyListingWrapper />}
                />
              }
            />
            <Route
              path="questions"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_QUESTION}
                  component={<TestQuestionListingWrapper />}
                />
              }
            />
            <Route
              path="questions/add"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_QUESTION}
                  actionName={UserModuleActionTypes.ADD}
                  component={<AddTestQuestionFormWrapper />}
                />
              }
            />
            <Route
              path="questions/edit/:id"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_QUESTION}
                  actionName={UserModuleActionTypes.EDIT}
                  component={<EditTestQuestionFormWrapper />}
                />
              }
            />

            <Route
              path="test-series"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_SERIES}
                  component={<TestSeriesListingWrapper />}
                />
              }
            />

            <Route
              path="test-series/add"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_SERIES}
                  actionName={UserModuleActionTypes.ADD}
                  component={<AddTestSeriesFormWrapper />}
                />
              }
            />
            <Route
              path="test-series/edit/:id"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_SERIES}
                  actionName={UserModuleActionTypes.EDIT}
                  component={<EditTestSeriesFormWrapper />}
                />
              }
            />
            <Route
              path="test-check"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_CHECK}
                  component={<TestCheckListingWrapper />}
                />
              }
            />
            <Route
              path="test-check/:id"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_CHECK}
                  actionName={UserModuleActionTypes.VIEW}
                  component={<SingleViewFormWrapper />}
                />
              }
            />
            <Route
              path="assign-test"
              element={
                <AuthHOC
                  moduleName={UserModuleNameTypes.TEST_ASSIGN}
                  component={<AssignTestWrapper />}
                />
              }
            />
          </Route>
          <Route
            path="recording-request"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.QUESTION}
                component={<RecordingRequestListingWrapper />}
              />
            }
          />
          <Route
            path="recording-rules"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.QUESTION}
                component={<RecordingRulesListingWrapper />}
              />
            }
          />

          <Route path="receipt" element={<Receipt />} />
          <Route path="*" element={<PageNotFound />} />
          <Route
            path="/contact"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.INQUIRIES}
                component={<NewInquiryListingWrapper />}
              />
            }
          />
          <Route
            path="/contact/:contactId"
            element={
              <AuthHOC
                moduleName={UserModuleNameTypes.INQUIRIES}
                component={<ViewNewInquiryWrapper />}
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default PageRoutes;
